<div class="page-container">
  <div class="relative page-edge-cut">
    @if (data) {
      <div class="form-card">
        <section>
          <h1 class="section-heading">
            {{ "ATA_CARNET.APPLICANT_TITLE" | translate }}
          </h1>
          <!-- Company Detail -->
          <div class="space-y-4 mt-5">
            <div class="flex flex-col">
              <!-- Header -->
              <div
                class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
                >
                <h2 class="text-lg font-semibold">
                  {{ "ATA_CARNET.COMPANY_TITLE" | translate }}
                </h2>
                <div
                  class="flex gap-4 text-dc-navy mt-2 sm:mt-0 underline cursor-pointer"
                  >
                  <button type="button">{{ "BUTTONS.EDIT" | translate }}</button>
                  <button type="button">
                    {{ "BUTTONS.REMOVE" | translate }}
                  </button>
                </div>
              </div>
              <!-- Rows -->
              <div class="flex flex-col divide-y divide-gray-200 mt-2 text-sm">
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.COMPANY_NAME" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">
                    {{ data.company.name }}
                  </div>
                </div>
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.BUSINESS_TYPE" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">
                    {{ data.company.businessTypes }}
                  </div>
                </div>
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.Mobile" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">
                    {{ data.company.countryCode }} {{ data.company.mobile }}
                  </div>
                </div>
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.Phone" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">
                    {{ data.company.phone }}
                  </div>
                </div>
              </div>
            </div>
            <!-- Authorized Representative -->
            <div class="flex flex-col">
              <!-- Header -->
              <div
                class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
                >
                <h2 class="text-lg font-semibold">
                  {{ "ATA_CARNET.REP_TITLE" | translate }}
                </h2>
                <div
                  class="flex gap-4 text-dc-navy mt-2 sm:mt-0 underline cursor-pointer"
                  >
                  <button type="button">{{ "BUTTONS.EDIT" | translate }}</button>
                  <button type="button">
                    {{ "BUTTONS.REMOVE" | translate }}
                  </button>
                </div>
              </div>
              <!-- Rows -->
              <div class="flex flex-col divide-y divide-gray-200 mt-2 text-sm">
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.COMPANY_NAME" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">
                    {{ data.representative.fullName }}
                  </div>
                </div>
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.Email" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">
                    {{ data.representative.email }}
                  </div>
                </div>
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.Mobile" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">
                    {{ data.representative.countryCode }}
                    {{ data.representative.mobile }}
                  </div>
                </div>
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.Phone" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">
                    {{ data.company.phone }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- cargo Detail -->
          <div class="space-y-4 mt-5">
            <div>
              <h1 class="text-xl font-semibold mb-2">
                {{ "ATA_CARNET.CARGO_INFO" | translate }}
              </h1>
              <div class="flex flex-col">
                <!-- Header -->
                <div
                  class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
                  >
                  <h2 class="text-lg font-semibold">
                    {{ "ATA_CARNET.CARGO_PURPOSE_CURRENCY" | translate }}
                  </h2>
                  <div
                    class="flex gap-4 text-dc-navy mt-2 sm:mt-0 underline cursor-pointer"
                    >
                    <button type="button">
                      {{ "BUTTONS.EDIT" | translate }}
                    </button>
                    <button type="button">
                      {{ "BUTTONS.REMOVE" | translate }}
                    </button>
                  </div>
                </div>
                <!-- Rows -->
                <div class="flex flex-col divide-y divide-gray-200 mt-2 text-sm">
                  <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                    <div class="font-medium sm:w-1/3">
                      {{ "ATA_CARNET.PURPOSE" | translate }}
                    </div>
                    <div class="sm:flex-1 text-dc-navy">
                      {{ data.cargo.purpose }}
                    </div>
                  </div>
                  <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                    <div class="font-medium sm:w-1/3">
                      {{ "ATA_CARNET.CURRENCY" | translate }}
                    </div>
                    <div class="sm:flex-1 text-dc-navy">
                      {{ data.cargo.currency }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Added Product list -->
          <section
            class="border border-dc-navy text-dc-navy divide-y divide-dc-navy"
            >
            <h1 class="text-xl font-semibold p-3">
              {{ "ATA_CARNET.TITLE_ADD_PRODUCT" | translate }}
            </h1>
            @for (p of products; track p) {
              <div class="relative p-3 bg-white">
                <h3 class="font-semibold mb-1">
                  {{ p.desc }}
                </h3>
                <div
                  class="absolute top-6 right-6 flex items-center space-x-4 text-dc-navy"
                  >
                  <button class="font-semibold underline" (click)="editProduct(p)">
                    {{ "BUTTONS.EDIT" | translate }}
                  </button>
                  <button
                    class="text-dc-navy hover:text-red-600 text-xl leading-none"
                    (click)="removeProduct(p)"
                    >
                    <i class="fas fa-remove"></i>
                  </button>
                </div>
                <!-- grid with six label/value pairs -->
                <div class="grid grid-cols-3 gap-x-8 gap-y-4">
                  <div>
                    <p class="text-sm text-dc-navy!">
                      {{ "PRODUCT_LIST.HS_CODE" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">{{ p.hsCode }}</p>
                    <p class="mt-4 text-sm text-dc-navy!">
                      {{ "PRODUCT_LIST.UNIT_PRICE" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.unitPrice | number : "1.0-0" }}
                    </p>
                  </div>
                  <div>
                    <p class="text-sm text-dc-navy!">
                      {{ "PRODUCT_LIST.COUNTRY_OF_ORIGIN" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">{{ p.origin }}</p>
                    <p class="mt-4 text-sm text-dc-navy!">
                      {{ "PRODUCT_LIST.MEASUREMENT_UNIT" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">{{ p.unit }}</p>
                  </div>
                  <div>
                    <p class="text-sm text-dc-navy!">
                      {{ "PRODUCT_LIST.QUANTITY" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.qty | number }}
                    </p>
                    <p class="mt-4 text-sm text-dc-navy!">
                      {{ "PRODUCT_LIST.WEIGHT" | translate }}
                    </p>
                    <p class="font-semibold text-dc-navy!">
                      {{ p.weight | number }}
                    </p>
                  </div>
                </div>
              </div>
            }
            <!-- pagination & record-count footer -->
            @if (products && products.length > 0) {
              <app-pagenation
                [data]="{ currentPage: 1, totalPages: 5, totalItems: 50 }"
                (pageChangeEvent)="loadPage($event)"
              ></app-pagenation>
            }
          </section>
          <!-- Travel Detail -->
          <div>
            <h1 class="text-xl font-semibold">
              {{ "ATA_CARNET.TRAVEL_TITLE" | translate }}
            </h1>
            <app-card-list
              [data]="journeyList"
              [viewType]="'list'"
            ></app-card-list>
          </div>
          <!-- process & collection -->
          <div class="space-y-4 mt-5">
            <div class="flex flex-col">
              <!-- Header -->
              <div
                class="flex flex-col sm:flex-row sm:items-center sm:justify-between"
                >
                <h2 class="text-lg font-semibold">
                  {{ "ATA_CARNET.PROCESS_TITLE" | translate }}
                </h2>
                <div
                  class="flex gap-5 text-dc-navy mt-2 sm:mt-0 underline cursor-pointer"
                  >
                  <button type="button">{{ "BUTTONS.EDIT" | translate }}</button>
                  <button type="button">
                    {{ "BUTTONS.REMOVE" | translate }}
                  </button>
                </div>
              </div>
              <!-- Rows -->
              <div class="flex flex-col divide-y divide-gray-200 mt-2 text-sm">
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.PROCESS_TYPE" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">{{ data.processing }}</div>
                </div>
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.COLLECTION" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">{{ data.collection }}</div>
                </div>
                <div class="flex flex-col sm:flex-row sm:gap-4 py-2">
                  <div class="font-medium sm:w-1/3">
                    {{ "ATA_CARNET.DeliveryAddress" | translate }}
                  </div>
                  <div class="sm:flex-1 text-dc-navy">-</div>
                </div>
              </div>
            </div>
          </div>
          <!-- Documents -->
          <div class="space-y-4 mt-5">
            <div class="flex flex-col">
              <h2 class="text-lg font-semibold">
                {{ "ATA_CARNET.DOCUMENTS" | translate }}
              </h2>
              <!-- Rows -->
              <div class="flex flex-col divide-y divide-gray-200 mt-2 text-sm">
                <div class="flex flex-col sm:flex-row sm:justify-between py-2">
                  <div class="font-medium">
                    {{ "ATA_CARNET.LPO" | translate }}
                  </div>
                  <div>-</div>
                  <a class="text-dc-navy underline cursor-pointer">{{
                    "BUTTONS.CHANGE" | translate
                  }}</a>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between py-2">
                  <div class="font-medium">
                    {{ "ATA_CARNET.FILE_INVOICE" | translate }}
                  </div>
                  <div>-</div>
                  <a class="text-dc-navy underline cursor-pointer">{{
                    "BUTTONS.CHANGE" | translate
                  }}</a>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between py-2">
                  <div class="font-medium">
                    {{ "ATA_CARNET.FILE_AUTH_LETTER" | translate }}
                  </div>
                  <div>-</div>
                  <a class="text-dc-navy underline cursor-pointer">{{
                    "BUTTONS.CHANGE" | translate
                  }}</a>
                </div>
                <div class="flex flex-col sm:flex-row sm:justify-between py-2">
                  <div class="font-medium">
                    {{ "ATA_CARNET.FILE_LETTER_PLEDGE" | translate }}
                  </div>
                  <div>-</div>
                  <a class="text-dc-navy underline cursor-pointer">{{
                    "BUTTONS.CHANGE" | translate
                  }}</a>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!--Action buttons   ═-->
        <div class="btn-section buttons-group">
          <app-button
            [type]="'button'"
            [label]="'BUTTONS.BACK_TO_APPLICATION' | translate"
            classesName="btn-edge-cut  btn-width-auto"
            (onBtnClick)="back()"
            />
            <app-button
              [type]="'button'"
              [label]="'BUTTONS.SAVE_CLOSE' | translate"
              classesName="card-edge-cut-white !btn-edge-cut btn-width-auto"
              (onBtnClick)="back()"
              />
            </div>
          </div>
        }
      </div>
    </div>

    <div>
      <app-service-progress
        [serviceName]="'ATA_CARNET.MODIFY_SERVICE' | translate"
        [completePercentage]="formProgress"
        />
      </div>